import { render, staticRenderFns } from "./page-pixel-table.vue?vue&type=template&id=6b3b3dea&"
import script from "./page-pixel-table.vue?vue&type=script&lang=js&"
export * from "./page-pixel-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports